const pad = (n) => String(n).padStart(2, '0');

// react-datepicker works with local `Date` objects, so a unit-time-zone day key (`YYYY-MM-DD`) is mapped to the
// local calendar day at noon (no DST edge) and back with local getters: the browser zone never shifts the day.
export const dayKeyToDate = (dayKey) => {
  const [year, month, day] = dayKey.split('-').map(Number);
  return new Date(year, month - 1, day, 12);
};

export const dateToDayKey = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

// `dayKeys` is sorted ascending. Returns the nearest active day in `direction` (-1 / 1), or null.
export const adjacentActiveDay = (dayKeys, current, direction) => {
  if (direction < 0) {
    const earlier = dayKeys.filter((key) => key < current);
    return earlier[earlier.length - 1] || null;
  }
  return dayKeys.find((key) => key > current) || null;
};
